import { render, staticRenderFns } from "./PhotoPublicDisplayOptions.vue?vue&type=template&id=0950d84d"
import script from "./PhotoPublicDisplayOptions.vue?vue&type=script&lang=js"
export * from "./PhotoPublicDisplayOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0950d84d')) {
      api.createRecord('0950d84d', component.options)
    } else {
      api.reload('0950d84d', component.options)
    }
    module.hot.accept("./PhotoPublicDisplayOptions.vue?vue&type=template&id=0950d84d", function () {
      api.rerender('0950d84d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/PublicDisplayOptions/PhotoPublicDisplayOptions.vue"
export default component.exports